<template>
  <div class="main">
    <div class="wrapper">
      <div class="navigation">
        <router-link to="/debito/lista-debito-veicular"
          ><img :src="icBack"
        /></router-link>
        <span>Débito Veicular</span>
        <router-link to="/home"><img :src="icClose" /></router-link>
      </div>
      <div class="content">
        <p>Selecione a opção de parcelamento</p>
        <div class="info border">
          <span class="badge">Parcelamento</span>

          <div class="list scroll">
            <div
              v-for="(parcela, index) in parcelas"
              :key="index"
              class="item border"
            >
              <input
                type="checkbox"
                :id="parcela.id"
                :checked="installmentChecked === parcela.id"
                @click="handleCheckboxChange(parcela.id)"
                :value="parcela.value"
              />
              <label
                :for="parcela.id"
                :class="{ selected: installmentChecked === parcela.id }"
                >{{ parcela.label }}</label
              >
              <small>R$ {{ parcela.value }}</small>
            </div>
          </div>
        </div>
        <img :src="next" class="nextStep" @click="handleNextStepClick" />
      </div>

      <FooterGlobal></FooterGlobal>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import icNext from '@/assets/svg/ic-next.svg'
import icClose from '@/assets/svg/ic-close.svg'
import icBack from '@/assets/svg/ic-back.svg'
import FooterGlobal from '@/components/Footer.vue'
import { timerToReturnToHome } from '../../helper/timer'

export default defineComponent({
  name: 'ParcelasDebitoVeicular',
  components: {
    FooterGlobal,
  },
  data() {
    timerToReturnToHome(40000)
    return {
      next: icNext,
      icClose: icClose,
      icBack: icBack,
      totalDebitos: 0,
      installmentChecked: null,
      listaParcelas: [], 
    }
  },
  computed: {
    // Opções de crédito (2x até 18x)
    parcelas() {
      return this.listaParcelas
        .filter((p) => {
          const n = Number(p.numParcelas)
          return n >= 2 && n <= 18
        })
        .map((p) => {
          const n = Number(p.numParcelas)
          return {
            id: n,
            label: `Crédito ${n}x`,
            value: Number(p.valorParcela).toFixed(2),
            totalParcela: p.totalParcela,
            numParcelas: n,
          }
        })
    },
  },
  created() {
    try {
      const dataDebito = JSON.parse(sessionStorage.getItem('totalDebito') || '{}')
      this.totalDebitos = dataDebito.totalDebitos || 0

      const raw = sessionStorage.getItem('dadosParcelas')
      const dados = raw ? JSON.parse(raw) : []

     
      this.listaParcelas = Array.isArray(dados) ? dados : dados?.dados || []
    } catch (e) {
      console.error('Erro ao carregar parcelas:', e)
      this.listaParcelas = []
    }
  },
  methods: {
    handleCheckboxChange(id) {
      this.installmentChecked = this.installmentChecked === id ? null : id
    },

    handleNextStepClick() {
      if (this.installmentChecked == null) {
        alert('Selecione uma opção para prosseguir')
        return
      }

      const selectedOption = this.parcelas.find(
        (p) => p.id === this.installmentChecked,
      )

      if (selectedOption) {
        sessionStorage.setItem(
          'selectedInstallmentValue',
          selectedOption.label.toUpperCase(),
        )
        sessionStorage.setItem('installmentSelect', String(selectedOption.id))
        sessionStorage.setItem(
          'valorParcelaSelecionada',
          selectedOption.value,
        )
        sessionStorage.setItem(
          'totalParcelaSelecionada',
          String(selectedOption.totalParcela ?? ''),
        )
      }

      this.$router.push('/debito/pagamento-debito-veicular-cartao')
    },
  },
})
</script>
